import { assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO__special_collections_info extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.SPECIAL_COLLECTIONS_INFO;

  /*
   * SERVER RUNTIME FIELDS
   */
  workspace_id!: string;

  //todo: use hash_sha256_content
  images_ids_viewed_on_search: Set<string>;
  //todo: use hash_sha256_content
  images_ids_favorites: Set<string>;

  /*
   * METHODS
   */

  constructor() {
    super();

    this.images_ids_viewed_on_search = new Set();
    this.images_ids_favorites = new Set();
  }

  assert_standard_fields(): void {
    assert_string_not_empty(this.workspace_id);
  }
}
